import styled from 'styled-components';

export const InputsWrapper = styled.div`
  display: flex;
  gap: 12px;
  width: 100%;

  flex: 1;
`;

export const DocumentInputWrapper = styled.div`
  display: flex;
  gap: 8px;
  width: 100%;

  .type-selector {
    min-width: 140px;

    .ant-form-item {
      margin-bottom: 0;
    }
  }

  .number-input {
    flex: 1;

    .ant-form-item {
      margin-bottom: 0;
    }
  }
`;
